// In order to edit some entity we have to make a deep copy of it.
// When user makes changes we reflet them into that clone which we call draft
// In case user cancels changes we just get rid of this draft, other wise we commit it
// Draft's shema can be differ from entity, so there are a few utils which help to create draft from entity

import defaults from 'lodash.defaults';
import { Sensor, SensorDraft } from '../../../models/Sensor';
import { ServiceAccount, ServiceAccountDraft } from '../../../models/ServiceAccount';
import { Vehicle, VehicleDraft, Source } from "../../../models/Vehicle";
import { Person, PersonDraft } from "../../../models/Person";
import { Division, DivisionDraft } from "../../../models/Division";

export function prepareSensorDraft (sensor: Readonly<Sensor>): SensorDraft
{
    const draft = Object.assign({}, sensor) as SensorDraft; // sensor could be null or undefined
    
    if(!draft.Display)
        draft.Display = '';
    
    return defaults<any, Partial<SensorDraft>>(draft, {
        VehicleId: null,
        GeotabId: null,
        
        AbsLevelMaximumRed: null,
        AbsLevelMinimumRed: null,
        AbsLevelMaximumYellow: null,
        AbsLevelMinimumYellow: null        
    });
}

export function prepareServiceAccountDraft(account: Readonly<ServiceAccount>): ServiceAccountDraft
{
    // ServiceAccount entity doesn't have Password field on the client side,
    // But in order to update a password on a server side we have to push ServiceAccountDraft to the server
    let draft = Object.assign<any, any, Partial<ServiceAccountDraft>>({}, account, {
        // reset these fields
        Password: '',
    });
    
    return defaults<any, Partial<ServiceAccountDraft>>(draft, {
        AutoImport: !account,
        // React expects text fields to be valid strings. Falsy values are treated differently
        Username: '',
        ServerUrl: '',
    });
}

export function prepareVehicleDraft(vehicle: Readonly<Vehicle>, source: Source): VehicleDraft
{
    let draft = { ...vehicle } as VehicleDraft;
    draft.Display = draft.Display || '';
    return defaults<any, Partial<VehicleDraft>>(draft, {
        ServiceAccountId: null,
        GeotabId: null,
        SourceId: source,
    });
}

export function perparePersonDraft(person: Readonly<Person>): PersonDraft
{
    // person could be null
    const draft = Object.assign({}, person, { Password: '', PasswordConfirmation: '' }) as PersonDraft;
    if(!draft.Firstname)
        draft.Firstname = '';
    if(!draft.Lastname)
        draft.Lastname = '';
    if(!draft.Username)
        draft.Username = '';
    if(!draft.IsAdministrator)
        draft.IsAdministrator = false;
    return draft;
}

export function prepareDivisionDraft(division: Readonly<Division>): DivisionDraft
{
    const draft = {...division} as DivisionDraft;
    draft.Name = draft.Name || '';
    draft.ParentName = draft.ParentName || '';
    return draft;
}


// WEBPACK FOOTER //
// ./src/app/utils/draft/index.ts